import React from 'react';

const ExceedTransactionLimit = ({ messages, isFrom = false, isShowDeliveryOptions = false, isShowChangePickupButton = false }) => {
    const getText = () => {
        if (isShowDeliveryOptions && !isShowChangePickupButton) {
            return messages?.errorTextHasManyDeliveryOptions;
        } else if (!isShowDeliveryOptions && isShowChangePickupButton) {
            return messages?.errorTextHasChangePickupLocation;
        } else if (isShowDeliveryOptions && isShowChangePickupButton) {
            return messages?.errorTextHasManyDeliveryOptionsOrChangePickup;
        }
        return '';
    };
    return (
        <>
            {isFrom ? messages?.errorTextFromExceedTransactionLimit : messages?.errorTextToExceedTransactionLimit}
            {getText() && (
                <>
                    <br />
                    <br />
                    {getText()}
                </>
            )}
        </>
    );
};
export default ExceedTransactionLimit;
